// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"f3fcd97d","134":"cf3b886a","429":"ea1aa200","488":"7a3bb395","532":"68768524","701":"55809f00","916":"909add27","944":"a88177d6"}[chunkId] + ".js";
};